import React from 'react'
// libs
import { ColorResult, SketchPicker } from 'react-color'
// components
import { PopoverModal } from 'components/UI'
import { SketchColorPicker as ReduxSketchPicker } from 'components/FormElements'

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const
  }
}

interface Props {
  name?: string
  trigger: JSX.Element
  onChange?: (color: string) => void
  initialColor: string | null
}

const ColorSelect: React.FC<Props> = ({ name, trigger, initialColor, onChange }) => {
  const [color, setColor] = React.useState(initialColor)

  const onColorChange = (color: string) => {
    setColor(color)
    onChange?.(color)
  }

  const onChangeComplete = (color: ColorResult) => {
    setColor(color.hex)
    onChange?.(color.hex)
  }

  return (
    <PopoverModal {...MODAL_PROPS} trigger={trigger}>
      {() =>
        name ? (
          <ReduxSketchPicker name={name} initialColor={initialColor} onChange={onColorChange} />
        ) : (
          <SketchPicker color={color || initialColor} onChangeComplete={onChangeComplete} />
        )
      }
    </PopoverModal>
  )
}

export default ColorSelect
